import { TableWithFeatures } from '@/affiliate-dashboard/components/base/table-with-features';
import {
  type PayoutFragment,
  useGetPayoutsHistoryQuery,
} from '@/affiliate-dashboard/graphql';
import { PageHeading } from '@/components/base/page-heading';
import { Skeleton } from '@/components/base/skeleton';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';
import invariant from 'tiny-invariant';
import { defaultColumns } from './columns';

const PAGE_SIZE = 8;

export function PayoutHistory({
  data,
  handlePageChange,
  totalPages,
  currentPage,
}: {
  data: (PayoutFragment | null)[];
  handlePageChange?: (page: number) => void;
  totalPages?: number;
  currentPage?: number;
}): JSX.Element {
  const intl = useIntl();
  const { t } = useTranslation();
  const columns = useMemo(() => defaultColumns(intl, { t }), [intl, t]);

  //   const handleSearch = (query: string) => {
  //     const filtered = data.filter((item) => {
  //       if (!item) return false;
  //       return Object.values(item).some((value) => {
  //         if (value === null || typeof value === 'object') {
  //           return false;
  //         }

  //         return value.toString().toLowerCase().includes(query.toLowerCase());
  //       });
  //     });

  //     return filtered;
  //   };

  return (
    <TableWithFeatures
      data={data}
      columns={columns}
      itemsPerPage={PAGE_SIZE}
      searchPlaceholder="Search commissions..."
      onPageChange={handlePageChange}
      totalPages={totalPages}
      page={currentPage}
    />
  );
}

export function PayoutHistoryWithData(): JSX.Element {
  const { t } = useTranslation();
  const { data, loading } = useGetPayoutsHistoryQuery();
  if (loading) {
    return (
      <div className="mx-auto flex h-full w-full flex-col gap-4">
        <Skeleton className="h-full max-h-32 w-full rounded-xl" />
      </div>
    );
  }

  invariant(data?.payoutsHistory, 'Data should be defined');

  return data?.payoutsHistory.length > 0 ? (
    <div className="flex flex-col">
      <PageHeading size="small">{t('affiliateWallet.title')}</PageHeading>
      <PayoutHistory data={data?.payoutsHistory} totalPages={4 / PAGE_SIZE} />
    </div>
  ) : (
    <></>
  );
}
